<template>
    <div class="ui segments in_segment">
        <LabelInputItem
            class="ui segment"
            v-for="(field_name, index) in field_names"
            :key="field_name+'card_vertical_main'"
            :core_waybill="core_waybill"
            :field_name="field_name"
            :is_fluid="true"
            :class="{
                blue: field_name == 'consignee_company_name',
                green: field_name == 'sender_company_name',
                'no top border': index == 0,
            }"
            :is_hidden_segment_border="true"
            :is_dont_hide_content="is_in_scanner_modal"
            :style="{
                padding: !is_can_update_field(field_name) ? '0' : ''
            }"
        >
        </LabelInputItem>

    </div>
</template>

<script>
import LabelInputItem from './label_input_item.vue'

export default {
    components: {
        LabelInputItem
    },
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        is_in_scanner_modal: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            field_names: [
                'original_number',
                'tracking_number',
                'note',
                'sender_company_name',
                'sender_name',
                'sender_phone',
                'consignee_company_name',
                'consignee_name',
                'consignee_phone',
                'consignee_address'
            ]
        }
    },
    computed: {
    },
    watch: {
        focus_field(ref_name){
            this.$refs[ref_name].focus()
        }
    },
    mounted() {
    },
    methods: {
        /*
         * ========================================================================
         * $parent
         * ========================================================================
         */
        is_can_update_field(field_name = "") {
            return this.$parent.is_can_update_field(field_name)
        },
    }
}
</script>

<style lang="scss" scoped>
    .segments .segment {
        padding: 0.5em 1em;
    }
    .in_segment {
        margin: 0 !important;
        border: 0 !important;
    }
</style>
